import React, { Component } from 'react'
import AsideNavbar from '../components/navbars/AsideNavbar'
import PreviousPaperAnalysisSection from '../components/previous_paper_analysis/PreviousPaperAnalysisSection'


import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";

import ScrollTopNavbar from '../components/navbars/ScrollTopNavbar';

import ReactGA from 'react-ga';
import { GoogleAnalyticsArray } from './GoogleAnalytics';

const FETCH_ISSTUDENTUSERVALID = gql` 
query($student_user_exam_id: Int!) {
    isStudentUserValid(student_user_exam_id: $student_user_exam_id){
        estatus
        current_plan_id
        expiry_date
        user_access_restictions
        isTrialUser
        module_restrictions
        
        previous_sets
     }
}

`;

const UPDATE_STUDENT_ANALYTICS = gql`
  mutation(
    $params:AnalyticsStudents1  
    ) {
        studentAnalytics(
        params: $params
     )
  }
`;


// Inline shimmer skeleton (stat cards + chart + table) shown while loading.
const PreviousPaperAnalysisShimmer = () => (
    <div className="py-4">
        <div className="rz-shimmer rz-skel-title" style={{ width: '35%', height: '24px' }} />
        <div className="row mt-3">
            {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="col-xl-3 col-lg-3 col-md-6 col-12 mb-4">
                    <div className="rz-skel-card border-0 text-center">
                        <div className="rz-shimmer rz-skel-circle mx-auto mb-3" style={{ width: '48px', height: '48px' }} />
                        <div className="rz-shimmer rz-skel-line mx-auto" style={{ width: '60%' }} />
                        <div className="rz-shimmer rz-skel-line sm mx-auto mb-0" style={{ width: '40%' }} />
                    </div>
                </div>
            ))}
        </div>
        <div className="rz-skel-card border-0 mb-4">
            <div className="rz-shimmer rz-skel-line" style={{ width: '25%' }} />
            <div className="rz-shimmer" style={{ width: '100%', height: '260px', borderRadius: '10px' }} />
        </div>
        <div className="rz-skel-card border-0">
            {Array.from({ length: 5 }).map((_, i) => (<div key={i} className="rz-shimmer rz-skel-line" style={{ width: '100%' }} />))}
        </div>
    </div>
);

class PreviousPaperAnalysis extends Component {
    constructor(props) {
        super(props)
        let pexamtype = "";
        if (Cookies.get("examid") == 1) {
            pexamtype = "0";
        }
        else if (Cookies.get("examid") == 2 || Cookies.get("examid") == 5) {
            pexamtype = "1";
        }
        this.state = {
            pexamtype: pexamtype,
            psubject: "0",
            defaulteventKey: "first",
            pyeartype: [],
            headerBottomImg: {
                Img: require('../../images/previous-paper-analysis.svg'),
                Title: "Previous Paper Analysis",
                width: 200,
                helpImg: require('../../images/Ask_me_for_Help.gif')
            },

            subject: "0",
            subjectValue: {
                value: "0",
                label: "Select All"
            },
            yeartype: [],
            yeartypevalue: [],
            examtype: "0",
            subexamtype: "1",
            subexamtypeValue: {
                value: "1",
                label: "MAINS"
            },
            submitError: "",



        }
    }
    componentDidMount = () => {

        this.addStudentAnalytics();


        const title = GoogleAnalyticsArray[0].Previous_Paper_Analysis_home;
        ReactGA.pageview('/student/previous-paper-analysis', ["rizee"], title);
    }

    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    
    addStudentAnalytics = e => {
        let addStudentObj = ""

        addStudentObj = {
            exam_id: parseInt(Cookies.get("examid")),
            student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
            analytics_module_page_id: 13,
            source :2

        }
        //console.log("addStudentObj",addStudentObj)

        this.submitpt(
            addStudentObj
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
        });
    }

    submitpt = async (
        params) => {
        await this.props.submitpt({
            variables: {
                params
            },
            update: (store, { data }) => {
                console.log("data",data)
                if (data.studentAnalytics) {
                    this.setState({
                        submitError:""
                    });
                }
            }
        });
    };
    searchSubmit = (childstate) => {

        const title = GoogleAnalyticsArray[0].Previous_Paper_Analysis_Detail_Page;
        ReactGA.pageview('/student/previous-paper-analysis', ["rizee"], title);

        let pexamtype = "";
        if (Cookies.get("examid") == 1) {
            console.log("w2");
            pexamtype = "0";
        }
        else if (Cookies.get("examid") == 2) {
            console.log("w3", childstate.subexamtype);
            pexamtype = childstate.subexamtype;
        }
        else if (Cookies.get("examid") == 5) {
            console.log("w4");
            if (childstate.examtype == "0") {
                pexamtype = "0";
            }
            else {
                pexamtype = childstate.subexamtype;
            }
        }
        this.setState({
            pexamtype: pexamtype,
            psubject: childstate.subject,
            pyeartype: childstate.yeartype,
            defaulteventKey: childstate.defaulteventKey,

            subject: childstate.subject,
            subjectValue: childstate.subjectValue,
            yeartype: childstate.yeartype,
            yeartypevalue: childstate.yeartypevalue,
            examtype: childstate.examtype,
            subexamtype: childstate.subexamtype,
            subexamtypeValue: childstate.subexamtypeValue

        });
    }
    render() {

        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");

        const isStudentUserValid = this.props.isStudentUserValid;
        const loading5 = isStudentUserValid.loading;
        const error5 = isStudentUserValid.error;

        if (error5 !== undefined) {
            alert("Server Error. " + error5.message);
            return null;
        }

        //console.log("getUserExplored", isStudentUserValid.isStudentUserValid);
        if (isStudentUserValid.isStudentUserValid != undefined) {
            if (isStudentUserValid.isStudentUserValid.estatus == 0) {
                Cookies.remove("token");
                Cookies.remove("username");
                Cookies.remove("refreshtoken");
                Cookies.remove("email");
                Cookies.remove("id");
                Cookies.remove("institutionid");
                Cookies.remove("userlevel");
                Cookies.remove("name");
                this.props.history.push("/student/login");
            }
            localStorage.removeItem('isStudentUserValid');
            localStorage.setItem(
                "isStudentUserValid",
                JSON.stringify(isStudentUserValid.isStudentUserValid)
            );
        }


        //for globals
        let studentGlobals = "";
        if (JSON.parse(localStorage.getItem("studentglobals")) != "") {
            studentGlobals = JSON.parse(localStorage.getItem("studentglobals"));
        }
        else {
            this.props.history.push("/student/login");
        }
        //for globalsubjects
        let globalsubjects = "";
        if (JSON.parse(localStorage.getItem("globalsubjects")) != "") {
            globalsubjects = JSON.parse(localStorage.getItem("globalsubjects"));
        }
        else {
            this.props.history.push("/student/login");
        }
        return (
            <div className={Cookies.get("toggle")}>
                <div className="student main-wrapper">
                    <div className="student header-area previous-paper-analysis-topnavbar">
                        <ScrollTopNavbar headerBottom={this.state.headerBottomImg} onClick={() => this.menuToggler()} />
                    </div>

                    
                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper min-height-remove pt-0">
                        {(loading5 == true) && (<PreviousPaperAnalysisShimmer />)}
                        {
                            !loading5 && (
                                <PreviousPaperAnalysisSection
                                    searchSubmit={this.searchSubmit}
                                    studentGlobals={studentGlobals}
                                    stateData={this.state}
                                    globalsubjects={globalsubjects}
                                    isStudentUserValid={isStudentUserValid.isStudentUserValid}

                                />)
                        }
                    </div>
                </div>
            </div>
        )
    }
}



export default withRouter(compose(
    graphql(FETCH_ISSTUDENTUSERVALID,
        {
            options: props => ({
                variables: {
                    student_user_exam_id: parseInt(Cookies.get("student_user_exam_id"))
                }
                ,
                // Shared cache entry; revalidated on navigation by utils/sessionValidity.
                fetchPolicy: 'cache-first'
            }), name: "isStudentUserValid"
        }),
        graphql(UPDATE_STUDENT_ANALYTICS, {
            name: "submitpt"
        }),

)(PreviousPaperAnalysis));